<template>
  <div class="multi-select-button-container">
    <div class="multi-select-button-opt__container">
      <a v-for="(option, idx) in options"
         :key="idx"
         :class="[selectedOptionClass(option), options.length % 3 == 0 ? 'multi-select-button-opt-3' : '']"
         class="multi-select-button-opt"
         @click="toggleSelected(option)"
      >
        {{ option }}
      </a>
    </div>
  </div>
</template>
<script>

export default {
  components: { },
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      require: true,
      default: ''
    },
    prePopulate: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      selectedOptions: []
    }
  },
  computed: {},
  mounted () {
    // pre populate options. This should really just be a prop that's from the parent component and shouldn't have a separate state here
    if (this.prePopulate.length > 0) {
      this.selectedOptions = this.prePopulate
    }
  },
  methods: {
    selectedOptionClass (option) {
      return { selected: this.selectedOptions.indexOf(option) !== -1 }
    },
    toggleSelected: function (option) {
      const i = this.selectedOptions.indexOf(option)

      if (i === -1) {
        this.selectedOptions.push(option)
      } else {
        this.selectedOptions.splice(i, 1)
      }
      this.$emit('update', this.selectedOptions)
    }
  }
}
</script>

<style scoped>
.multi-select-button-container {
  width: 100%;
  margin-bottom: 10px;
  padding: 15px;
}

.multi-select-button-opt__containerr:last-child {
  margin-bottom: 0;
}

.multi-select-button-opt__container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 5px;
}

.multi-select-button-opt {
  box-sizing: border-box;
  padding: 5px;
  margin: 2px;
  border: 1px dashed;
  border-radius: 5px;
  display: block;
  text-align: center;
  flex-basis: 49%;
  cursor: pointer;
}

.multi-select-button-opt-3 {
  flex-basis: 32%;
}

.multi-select-button-opt.selected {
  color: white;
  background-color: #05295c;
}

.selected {
  border: 1px solid;
  font-weight: 700;
}
</style>
